var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.194,
    height: 18.916,
    viewBox: "0 0 21.194 18.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11460",
    "data-name": "Group 11460",
    transform: "translate(-193.8 -128.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29634",
    "data-name": "Path 29634",
    d: "M773.3-394.933v8.078h20.194v-8.078h-6.088v2.693h-7.961v-2.693Z",
    transform: "translate(-579 534)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11456",
    "data-name": "Group 11456",
    transform: "translate(-588 536.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29635",
    "data-name": "Path 29635",
    d: "M535.646,39.219l-4.437,3.617,4.437,3.181",
    transform: "translate(749.539 134.2) rotate(-90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29636",
    "data-name": "Path 29636",
    d: "M533.9,44.7h9.572",
    transform: "translate(747.6 136.629) rotate(-90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.0ca9b8d9fc63625614ab82b627d4f98a.svg";
export { ForwardRef as ReactComponent };